import React, { useEffect, useState } from "react";
import { BannedIpInterface } from "src/store/mine_craft/bannedIpsSlice";

import { Button, Form, Input, InputNumber, Select, Switch } from "antd";

interface propsInterface {
  params?: BannedIpInterface | undefined;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();
  const [permanent, setPermanent] = useState(params?.permanent ?? true);

  useEffect(() => {
    form.resetFields();
    setPermanent(params?.permanent ?? true);
  }, [params, form]);

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <Form.Item name='ip' label="IP Address" rules={[{ required: true, message: 'IP address is required' }]}>
        <Input placeholder='e.g. 192.168.1.1' />
      </Form.Item>

      <Form.Item name='reason' label="Reason">
        <Input.TextArea placeholder='Ban reason' rows={3} />
      </Form.Item>

      <Form.Item label="Permanent" name='permanent' valuePropName='checked'>
        <Switch
          checkedChildren='yes'
          unCheckedChildren='no'
          onChange={(checked) => setPermanent(checked)}
        />
      </Form.Item>

      {!permanent && (
        <>
          <Form.Item name='period' label="Period" rules={[{ required: true, message: 'Period is required' }]}>
            <InputNumber min={1} placeholder='e.g. 30' style={{ width: '100%' }} />
          </Form.Item>

          <Form.Item name='duration' label="Duration" rules={[{ required: true, message: 'Duration is required' }]}>
            <Select placeholder='Select duration unit'>
              <Select.Option value='minutes'>Minutes</Select.Option>
              <Select.Option value='hours'>Hours</Select.Option>
              <Select.Option value='days'>Days</Select.Option>
            </Select>
          </Form.Item>
        </>
      )}

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
